// eslint-disable-next-line import/no-extraneous-dependencies
import * as qs from 'querystring';
import axios from '@/mod/axiosMod';

export default {
  // https://km.sankuai.com/page/1012530818 接口文档

  /**
   * 根据poi查找bd信息
   * @param poiIdList String
   * @returns {*}
   */
  getBDInfoByPoiIds(poiIds) {
    return axios.post(
      '/api/cdb/poi/v1/customer/v1/queryBDByPoiIds',
      qs.stringify({ poiIds }),
      {
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      },
    );
  },

  /**
   * 根据bd查找bd手机号非加密
   * @param poiId 门店id
   * @param misId mis号
   * @returns {*}
   */
  getBDPhoneByPoiId(poiId, misId) {
    return axios.post(
      '/api/cdb/poi/v1/customer/v1/queryBDPhoneByPoiId',
      qs.stringify({ poiId, misId }),
      {
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      },
    );
  },
};
